<template>
  <Layout>

    <div class="row">
      <div class="col-12">
        <div class="mb-2 d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

          <div class="page-title-right">

            <b-button v-b-modal.modal-lg variant="primary" @click="closeModal">
              <b>Nouveau</b>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 text-right">
      <b-modal id="modal-lg" v-model="showModal" size="md" centered :title="modalTitle" title-class="font-18"
        hide-footer>
        <form @submit.prevent="onSubmit" v-if="!updating">
          <div class="row">
            <div class="col">
              <label>{{ $t('filemanager.modal.actions.name') }} </label>
              <input type="text" v-model.trim="forms.name" class="form-control" required />
            </div>
          </div>
          <div class="row mt-4 mb-12">
            <div class="col">
              <label>{{ $t("pages.documentType.type") }} </label>
              <select class="form-control" v-model="forms.type">
                <option v-for="(type, index) in actionTypes" :key="index" :value="type.id">
                  {{ $t(`pages.actions.${type.name}`) }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-left">
              <br />
              <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                {{ $t("pages.metadata.save") }}
              </button>
              <button class="btn btn-primary mr-2" type="button" v-else disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t("pages.metadata.saving") }}
              </button>
              <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                {{ $t("pages.metadata.cancel") }}
              </button>
            </div>
          </div>
        </form>

        <form @submit.prevent="onSubmit" v-else>
          <div class="row">
            <div class="col">
              <label>{{ $t('filemanager.modal.actions.name') }} </label>
              <input type="text" v-model.trim="selectedItem.name" class="form-control" required />
            </div>
            <div class="col">
              <label>{{ $t("pages.documentType.type") }} </label>
              <select class="form-control" v-model="selectedItem.actionType_id">
                <option v-for="(type, index) in actionTypes" :key="index" :value="type.id">
                  {{ $t(`pages.actions.${type.name}`) }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-left">
              <br />
              <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                {{ $t("pages.metadata.save") }}
              </button>
              <button class="btn btn-primary mr-2" type="button" v-else disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t("pages.metadata.saving") }}
              </button>
              <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                {{ $t("pages.metadata.cancel") }}
              </button>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
    <div v-if="isLoadingData" class="mt-2">
      <b-skeleton-table :rows="6" :columns="3"></b-skeleton-table>
    </div>
    <table class="table table-hover mt-2" v-else-if="actions.length > 0">
      <thead class="thead-light">
        <tr>
          <th class="text-left">{{ $t("pages.roles.name") }}</th>
          <th class="text-left">{{ $t("pages.roles.type") }}</th>
          <th class="text-left">Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(action, index) in pageOfItems" :key="index" :value="action">
          <td>{{ action.name }}</td>
          <td>{{ $t(`pages.actions.${action.action_name}`) }}</td>
          <td>{{ $d(new Date(action.created_at), 'long') }}</td>
          <td class="text-center">
            <b-dropdown class="card-drop" variant="white" right v-if="![1, 2].includes(action.id)" toggle-class="p-0">
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="updateActionModal(action)">
                {{ $t("pages.metadata.edit") }}
              </b-dropdown-item>
              <b-dropdown-item @click.prevent="onDelete(action.id)">
                {{ $t("pages.metadata.delete") }}
              </b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center empty-state-container" v-else>
      <div class="row">
        <div class="col-md-3 mx-auto">
          <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
        </div>
      </div>
      <h4 class="text-center">{{ $t("pages.actions.empty.title") }}</h4>
      <p class="mt-2">{{ $t("pages.actions.empty.text") }}</p>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <div class="text-center">
          <jw-pagination :pageSize="pageSize" :items="actions" @changePage="onChangePage" :labels="labels"
            class="text-center"></jw-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  page: {
    title: "Actions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    LottieAnimation
  },
  data() {
    return {
      title: "menuitems.actions.title",
      items: [
        {
          text: "Workflow",
          href: "/",
        },
        {
          text: "Actions",
          active: true,
        },
      ],
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 5,
      isLoadingData: false,
      isLoading: false,
      isDeleting: false,
      showModal: false,
      updating: false,
      selectedItem: {},
      actionTypes: {},
      forms: {
        name: "",
        type: "",
      },
    };
  },
  computed: {
    ...mapState({
      actions: (state) => state.actions.actions,
    }),
    modalTitle() {
      return this.updating ? this.$t('pages.actions.actions.update') : this.$t('pages.actions.actions.create');
    },
  },
  methods: {
    ...mapActions([
      "getActionTypes",
      "createAction",
      "getActions",
      "updateAction",
      "deleteAction",
    ]),
    closeModal() {
      this.showModal = false;
      this.forms = {
        id: null,
        name: "",
        type: "",
      };
      this.updating = false;
      this.selectedItem = {
        id: null,
        name: "",
        actionType_id: "",
      };
    },
    updateActionModal(action) {
      this.showModal = true;
      this.updating = true;
      this.selectedItem = {
        id: action.id,
        name: action.name,
        actionType_id: action.actionType_id,
      };
    },
    onSubmit() {
      if (this.updating) {
        this.isLoading = true;
        this.updateAction(this.selectedItem)
          .then((response) => {
            if (response.status === 200) {
              this.isLoading = false;
              this.$toasted.success(this.$t('pages.actions.actions.updated'));
              this.closeModal();
              this.getActions();
            }
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.actions.actions.fillin'));
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
            }
          });
      } else {
        let formData = new FormData();
        formData.append("name", this.forms.name);
        formData.append("actionType_id", this.forms.type);
        this.createAction(formData)
          .then((response) => {
            if (response.status === 201) {
              this.isLoading = false;
              this.$toasted.success(this.$t('pages.actions.actions.created'));
              this.closeModal();
              this.getActions();
            }
          })
          .catch((error) => {
            if (error) {
              this.isLoading = true;
              this.$toasted.error(this.$t('pages.actions.actions.exists'));
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
            }
          });        
      }
    },
    onDelete(id) {
      if (this.$can("delete", "actions")) {
        this.$swal
          .fire({
            // title: this.$t('pages.actions.actions.confirm'),
            showCancelButton: true,
            confirmButtonText: this.$t('pages.actions.actions.btn.delete'),
            cancelButtonText: this.$t('pages.actions.actions.btn.cancel'),
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.isDeleting = true;
             this.deleteAction(id).then((response) => {
                if (response.status === 200) {
                  this.isDeleting = false;
                  this.$toasted.success(this.$t('pages.actions.actions.deleted'));
                }
              });
            }
          });
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden_1'));
      }
    },
    resetModal() {
      this.forms = "";
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
  },
  created() {
    if (this.$can("list", "actions")) {
       this.isLoadingData = true;
      this.getActionTypes()
        .then((response) => {
          if (response.status == 200) {
            this.actionTypes = response.data;
            this.isLoading = false;
            this.isLoadingData = false;
          } else {
            this.isLoading = false;
            this.isLoadingData = false;
          }
        })
        .catch(() => {
          this.isLoadingData = false;
        });

      this.getActions().finally(() => {
        this.isLoadingData = false;
        this.isLoading = false;
      });
    }
  },
};
</script>


